type StaticRoutes = Array<{ link: string; title: string }>;

export const staticRoutes: StaticRoutes = [
  {
    title: 'Kontakt',
    link: '/kontakt/',
  },
  {
    title: 'Wszystkie kierunki',
    link: '/wszystkie-kierunki/',
  },
  {
    title: 'Mapa strony',
    link: '/mapa-strony/',
  },
];
